// extracted by mini-css-extract-plugin
export default {"tableRow":"ArticlesTable_tableRow__itjEQ"};